import { Platform, Text } from 'react-native'
import { convertLineHeight, convertPercentageToNumber, styled } from '~/utils'

const IS_IOS = Platform.OS === 'ios'

export const Title = styled(Text, theme => {
  return {
    base: {
      justifyContent: 'space-between',
      textAlign: IS_IOS ? 'center' : 'left',
      color: theme.colorTextNeutralDefault,
      fontSize: theme.fontSizeFourpulse,
      lineHeight: convertLineHeight(
        theme.fontSizeFourpulse,
        theme.lineHeightSmall
      ),
      fontFamily: theme.fontFamily.bold,
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
    },
  }
})
